var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.entity.propertyUpdates,"hide-actions":"","pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('property-update-row',{attrs:{"value":props.item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }